import classnames from "classnames";
import {PropsWithChildren, useId} from "react";

import {KEY_TAB} from "@/wcag.ts";

import styles from "./RadioButton.module.css";

interface RadioButtonProps extends PropsWithChildren {
  className?: string;
  checked?: boolean;
  onChange: (checked: boolean) => void;
  readOnly?: boolean;
}

export const RadioButton = ({children, className, checked, onChange, readOnly}: RadioButtonProps) => {
  const inputId = useId();
  return (
    <div
      className={classnames(
        "form-check d-flex justify-content-between p-2 w-100 border cursor-pointer rounded rounded-3",
        className,
        styles.radioButton
      )}
      role="radio"
      tabIndex={0}
      onClick={() => onChange(!checked)}
      onKeyDown={(e) => {
        if (e.key !== KEY_TAB) {
          onChange(!checked);
        }
      }}
    >
      <label htmlFor={inputId} className="form-check-label w-95 cursor-pointer">
        {children}
      </label>
      <input
        id={inputId}
        className="form-check-input cursor-pointer"
        type="radio"
        tabIndex={-1}
        readOnly={readOnly}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
    </div>
  );
};
